import { render, staticRenderFns } from "./BulmaCarousel.vue?vue&type=template&id=dda4998a"
import script from "./BulmaCarousel.vue?vue&type=script&lang=js"
export * from "./BulmaCarousel.vue?vue&type=script&lang=js"
import style0 from "./BulmaCarousel.vue?vue&type=style&index=0&id=dda4998a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports